var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOutpatientLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48.4 64.5",
    style: {
      enableBackground: "new 0 0 48.4 64.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F4DFE4;}\n\t.st1{fill:#E1718B;}\n\t.st2{fill:#FFF8E0;}\n\t.st3{fill:#EDCE68;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_895",
    transform: "translate(-61.093 -0.052)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_457"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.5,29.9c1.6,0,2.8-1.3,2.8-2.9s-1.3-2.8-2.9-2.8s-2.8,1.3-2.8,2.9c0,1.5,1.3,2.8,2.8,2.8H95.5z  M108.5,14.6v44.2c-0.1,2.7-2.3,4.8-5,4.7H67.1c-2.7,0.1-4.9-2.1-5-4.7V14.6c0.1-2.7,2.3-4.8,5-4.7h7v4.4h22.4V9.9h7 C106.2,9.8,108.4,11.9,108.5,14.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.9,64.5c-3.1,0-5.8-2.5-5.8-5.7l0-44.2c0.1-3.3,2.8-5.8,6-5.7l8,0v4.4h20.4V8.9h8c3.2-0.1,5.9,2.5,6,5.7 v44.2c-0.1,3.3-2.7,5.8-6,5.7H67.1C67,64.5,67,64.5,66.9,64.5z M67,10.9c-2.1,0-3.8,1.7-3.9,3.8l0,44.2c0.1,2.1,1.8,3.8,4,3.7 h36.4c2.1,0.1,3.9-1.6,4-3.8V14.6c-0.1-2.1-1.8-3.8-3.9-3.8c0,0-0.1,0-0.1,0l-6,0v4.4H73.1v-4.4L67,10.9C67,10.9,67,10.9,67,10.9z  M95.5,30.9h-0.1c-2.1,0-3.7-1.7-3.8-3.8c0-1,0.4-2,1.1-2.7c0.7-0.7,1.7-1.2,2.7-1.2c1.1,0,2,0.4,2.7,1.1c0.7,0.7,1.2,1.7,1.2,2.7 C99.3,29.1,97.6,30.9,95.5,30.9L95.5,30.9z M95.4,25.2C95.4,25.2,95.4,25.2,95.4,25.2c-0.5,0-1,0.2-1.3,0.6 c-0.3,0.4-0.5,0.8-0.5,1.3c0,1,0.8,1.8,1.8,1.8h0.1c1,0,1.8-0.9,1.8-1.9c0-0.5-0.2-0.9-0.6-1.3C96.4,25.4,95.9,25.2,95.4,25.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_458"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M95.5,29.9h-0.1c-1.6,0-2.8-1.3-2.8-2.9c0-1.6,1.3-2.8,2.9-2.8s2.8,1.3,2.8,2.9C98.3,28.7,97,29.9,95.5,29.9z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_459"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M96.5,9.9v4.4H74.1V5.1H80C80.6,2.7,82.8,1,85.2,1c2.5-0.1,4.7,1.6,5.3,4.1h6V9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.5,15.3H74.1c-0.6,0-1-0.4-1-1V5.1c0-0.6,0.4-1,1-1h5.2c1-2.4,3.3-4.1,6-4.1c0.1,0,0.1,0,0.1,0 c2.6,0,5,1.7,5.9,4.1h5.2c0.6,0,1,0.4,1,1v9.2C97.5,14.8,97,15.3,96.5,15.3z M75.1,13.3h20.4V6.1h-5c-0.5,0-0.9-0.3-1-0.8 c-0.5-2-2.3-3.4-4.3-3.3c0,0,0,0,0,0c-2,0-3.8,1.4-4.3,3.3c-0.1,0.4-0.5,0.8-1,0.8h-4.9V13.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_882",
    transform: "translate(61.001 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_461"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.6,50.8c-0.6,0-1.1,0.5-1.1,1c0,0.6,0.5,1.1,1.1,1.1H34c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1-1.1-1H14.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_462"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.7,57.6h27.2c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1-1.1-1H10.7c-0.6,0-1.1,0.5-1.1,1 C9.6,57.1,10.1,57.6,10.7,57.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_463"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.6,32.8c0.1,0.5,0.5,0.9,1,0.9H19V40c0,4.6,3.7,8.3,8.3,8.3c4.6,0,8.3-3.7,8.3-8.3c0,0,0,0,0,0v-9.2 c2.1-0.6,3.2-2.8,2.6-4.9c-0.6-2.1-2.8-3.2-4.9-2.6s-3.2,2.8-2.6,4.9c0.4,1.3,1.5,2.3,2.8,2.6V40c0,3.4-2.8,6.2-6.2,6.2 c-3.4,0-6.2-2.8-6.2-6.2c0,0,0,0,0,0v-6.3h5.3c0.5,0,0.9-0.4,1-0.9l2.3-12.6c0.1-0.3,0-0.6-0.2-0.9c-0.2-0.2-0.5-0.4-0.8-0.4 h-2.2v-0.5c0-0.6-0.5-1.1-1.1-1.1s-1.1,0.5-1.1,1.1l0,0v2.9c0,0.6,0.5,1.1,1.1,1.1s1.1-0.5,1.1-1.1l0,0V21h1l-1.9,10.6H14.5 L12.6,21h1.1v0.3c0,0.6,0.5,1.1,1.1,1.1s1.1-0.5,1.1-1.1l0,0v-2.9c0-0.6-0.5-1.1-1.1-1.1s-1.1,0.5-1.1,1.1l0,0v0.5h-2.3 c-0.3,0-0.6,0.2-0.8,0.4c-0.2,0.2-0.3,0.6-0.2,0.9L12.6,32.8z M32.6,27.1c0-1,0.8-1.8,1.8-1.8c1,0,1.8,0.8,1.8,1.8 c0,1-0.8,1.8-1.7,1.8h-0.1C33.4,28.9,32.6,28.1,32.6,27.1z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutpatientLight);
export default __webpack_public_path__ + "static/media/outpatient-light.0bc307f6b0b192c0d3c5355e57bb06b5.svg";
export { ForwardRef as ReactComponent };